import { useState, useEffect } from "react";
import { Modal, Input, Button, message } from "antd";
import { buttonSpinner } from "../assets/icons";
import { forgotPassword, resetPassword } from "../api/userServices";
export default function ForgotPasswordModal({ open, setOpen }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [VerifyLoading, setVerifyLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [resendTimer]);

  const handleEmailSubmit = async () => {
    message.destroy();
    if (loading) return; // Prevent multiple submissions
    if (!email) return message.error("Please enter your email");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return message.error("Please enter a valid email address");
    }
    setLoading(true);
    try {
      const response = await forgotPassword(email);
      if (response.status) {
        message.success("OTP sent to your email");
        setStep(2);
        setResendTimer(30); // start resend timer
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    if (!otp) return message.error("Please enter the OTP");
    setVerifyLoading(true);
    try {
      const response = await resetPassword({ email, otp });

      if (response.status) {
        message.success("New password sent to your email");
        resetForm();
        setOpen(false);
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setVerifyLoading(false);
    }
  };

  const resendOtp = async () => {
    if (resendTimer > 0 || loading) return;
    setLoading(true);
    setOtp("");
    message.destroy();
    try {
      const response = await forgotPassword(email);
      if (response.status) {
        message.success("OTP sent to your email");
        setStep(2);
        setResendTimer(30);
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setStep(1);
    setEmail("");
    setOtp("");
    setResendTimer(0);
  };

  return (
    <>
      <button
        className="text-sm cursor-pointer text-indigo-500 no-underline hover:text-indigo-500 hover:underline"
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      >
        Forgot Password?
      </button>

      <Modal
        title="Forgot Password"
        open={open}
        onCancel={() => {
          setOpen(false);
          resetForm();
        }}
        footer={null}
      >
        {step === 1 && (
          <div className="space-y-4">
            <p>Enter your registered email address:</p>
            <Input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
            />
            <button
              className="w-full bg-lightBlue text-white hover:bg-darkBlue active:bg-blue-800 border-none px-6 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed  "
              disabled={loading || !email}
              onClick={handleEmailSubmit}
            >
              {loading ? buttonSpinner : "Send OTP"}
            </button>
          </div>
        )}
        {step === 2 && (
          <div className="space-y-4">
            <p>
              Enter the OTP sent to <strong>{email}</strong>
            </p>
            <Input.OTP
              length={6}
              value={otp}
              onChange={setOtp}
              autoFocus
              inputMode="numeric"
              className="w-full max-w-xs mx-auto"
            />
            <div className=" w-full flex justify-between items-center">
              <Button
                type="link"
                onClick={resendOtp}
                disabled={resendTimer > 0 || loading}
              >
                {resendTimer > 0
                  ? `Resend OTP in ${resendTimer}s`
                  : "Resend OTP"}
              </Button>

              <button
                className="w-full bg-lightBlue text-white hover:bg-darkBlue border-none px-2 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={otp.length < 6 || VerifyLoading}
                onClick={handleOtpSubmit}
              >
                {VerifyLoading ? buttonSpinner : "Verify OTP"}
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
